// common/services/createTodoToProjects.js  (CREATE)

import { isLoaded, isLoading } from "../actions";
import Alert from "../../../Common/Alert";
import API from "../../../Common/Network/API";

export async function createTodoToProject(state, dispatch, getUser,handleClose, pt_id,storyTitle,ADD_TO_TODO_PROJECTS) {
  if(storyTitle === state.taskTitle.value){
    Alert("warning", "Please change user story title ")
    dispatch(isLoaded());
  }else if(state.agileProjectSelected !== ""){
  dispatch(isLoading());
   if (state.taskTitle.value.trim() !== "" && state.taskDescription.value.trim() !== "" && state.acceptanceCriteria.value.trim() !== "") {
    try {
      var response = await API.post("private_todo.php", {
        crop: getUser.corp,
        action: "add",
        title: state.taskTitle.value,
        description: state.taskDescription.value,
        added_by: getUser.empId,
        acceptanceCriteria: state.acceptanceCriteria.value,
        added_to: state.userSelected === "" ? state.id.value : state.userSelected,
        storyPoints: state.storySelected === "" ? state.storyPoints.value : state.storySelected,
        priorityLevel: state.prioritySelected === "" ? state.priorityLevel.value : state.prioritySelected,
        idea_id: state.epicSelected === "" ? state.ideaId.value : state.epicSelected,
        projectId:state.agileProjectSelected,
        device_id: state.device_id,
        pt_id:pt_id
      }, {}, false);
      if (response.status === 'True') {
        Alert("success", ADD_TO_TODO_PROJECTS);
      }
    } catch (error) {
      Alert('error', error.message);
      dispatch(isLoaded());
    }
    handleClose()
  }
 
  else {
    Alert("warning", "Please enter required fields ")
    dispatch(isLoaded());
  }
}else{
  Alert("warning", "Please select the Agile Project ")
  dispatch(isLoaded());
}
} 